// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export const ConfigContext = registerClientReference(
function() { throw new Error("Attempted to call ConfigContext() from the server but ConfigContext is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/app/config-provider.tsx",
"ConfigContext",
);export const ConfigProvider = registerClientReference(
function() { throw new Error("Attempted to call ConfigProvider() from the server but ConfigProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/app/config-provider.tsx",
"ConfigProvider",
);